export enum MediaView {
  MobileView = 'mobileView',
  TabletView = 'tabletView',
  DesktopView = 'desktopView'
}
